import type { dynamicObj } from 'src/pages/assets';
import { isObjectEmtpy } from 'src/utils/general';
import { useSettingStore } from 'src/store/main';
import { UserOrg } from 'src/utils/organization/index';
import { user_sub_org_id_setting, allSubOrgsMenu } from 'src/constants';

export const UserSubOrg = {
  async setSubOrgId(sub_org_id: string) {
    const settings_store = useSettingStore();
    const saved_sub_org_id = await settings_store.getSetting(user_sub_org_id_setting);
    if (saved_sub_org_id === sub_org_id) {
      return;
    }
    await settings_store.setUserPreferences(
      user_sub_org_id_setting,
      sub_org_id,
    );
  },

  getSubOrgbyId(sub_org_id: string) {
    let found_sub_org = {} as dynamicObj;
    if (!sub_org_id) {
      return found_sub_org;
    }

    const organizations = UserOrg.getFromCache();
    if (!organizations || !Array.isArray(organizations)) {
      return found_sub_org;
    }

    for (const org of organizations) {
      if (
        Object.keys(org).length === 0 ||
        !org.sub_organisations ||
        !Array.isArray(org.sub_organisations)
      ) {
        continue;
      }

      for (const sub_org of org.sub_organisations) {
        if (org.id == sub_org_id) {
          found_sub_org = allSubOrgsMenu;
          found_sub_org.id = sub_org_id;
          found_sub_org.org_id = sub_org_id;
          break;
        }

        if (sub_org.id !== sub_org_id) {
          continue;
        }

        found_sub_org = sub_org;
        break;
      }
    }

    return found_sub_org;
  },

  async getSubOrgWithTryOnce(sub_org_id: string) {
    try {
      let sub_org = {} as dynamicObj;
      sub_org = this.getSubOrgbyId(sub_org_id);
      if (!isObjectEmtpy(sub_org)) {
        return sub_org;
      }

      await UserOrg.fetchFromServer();
      return this.getSubOrgbyId(sub_org_id);
    } catch (err) {
      return {} as dynamicObj;
    }
  },

  getSubOrgs() {
    const organizations = UserOrg.get();
    if (!organizations || !Array.isArray(organizations)) {
      return [];
    }

    const first_record = organizations[0];
    if (
      !first_record ||
      Object.keys(first_record).length === 0 ||
      !first_record.sub_organisations
    ) {
      return [];
    }

    const sub_organisations = first_record.sub_organisations;
    if (!sub_organisations || !Array.isArray(sub_organisations)) {
      return [];
    }

    return sub_organisations as dynamicObj[];
  },

  geSubOrgIdFromOrganizations() {
    let sub_org_id = '';
    const sub_organisations = this.getSubOrgs();
    if (sub_organisations.length === 0) {
      return sub_org_id;
    }

    let first_sub_organisation = sub_organisations[0];
    if (
      !first_sub_organisation ||
      Object.keys(first_sub_organisation).length === 0
    ) {
      return sub_org_id;
    }
    const organizations: dynamicObj = UserOrg.getFromCache();
    if (organizations[0].id === first_sub_organisation.id) {
      first_sub_organisation = sub_organisations[1];
    }
    sub_org_id = first_sub_organisation.id;
    return sub_org_id;
  },
  async get() {
    try {
      const settings_store = useSettingStore();
      const sub_org_id =
        await settings_store.getSetting(user_sub_org_id_setting) || ('' as string);
      return String(sub_org_id);
    } catch (err) {
      logError(err);
    }
  },
};
